import { AppState } from "../data/redux-state"
import { formatDateTime } from "./format"

const countries = require("i18n-iso-countries")
const { createFileName } = require("use-react-screenshot")

export const downloadPng = (
  props: AppState,
  image: any,
  { name = "gcci_fig", extension = "png" } = {}
) => {
  const currentDate = new Date()
  let fileName = ""

  for (let i = 0; i < props.subVariable.length; i++) {
    if (fileName === "") fileName = fileName + props.subVariable[i]
    else fileName = fileName + "_" + props.subVariable[i]
  }

  for (let i = 0; i < props.geoRegion.length; i++) {
    let countryCode = countries.getAlpha3Code(props.geoRegion[i], "en")
    if (countryCode) fileName = fileName + "_" + countryCode
    else fileName = fileName + "_" + props.geoRegion[i]
  }

  fileName = fileName + "_" + formatDateTime(currentDate)

  fileName = fileName.replace(/ /g, "_")

  const a = document.createElement("a")
  a.href = image
  a.download = createFileName(extension, fileName)
  a.click()
}
